export default __webpack_public_path__ + "static/media/bg.93044c31.png";